<div attr.tid="{{childConfig.config.controlName}}" *ngIf="!childConfig.config.isHidden" class="tam-contact-control">
    <div [style.width.px]="childConfig.css.width">
        <kendo-multiselect #entitylist [data]="suggestionItems" [filterable]="true"
            [popupSettings]="{appendTo: 'component'}" (filterChange)="handleFilter($event)" [disabled]="readOnly"
            [textField]="'name'" [valueField]="'id'" [autoClose]="isAutoClose" [(ngModel)]="selectedItems"
            (valueChange)="valueChange($event)" (mousedown)="$event.preventDefault()"
            (open)="onOpen($event)" (focus)="entitylist.toggle(true)">
            <div>
                <ng-template kendoMultiSelectItemTemplate let-dataItem>
                    <div [ngClass]="{'med-fly':dataItem.id ===searchId}">
                        <span>{{dataItem.name }} </span><span *ngIf="dataItem.id === searchId"
                            class='new-jobtitle-hint'>
                            (New job title)</span>
                    </div>
                </ng-template>
            </div>
        </kendo-multiselect>
    </div>
    <label [hidden]="isMatchJobTitle" class="dis-row"> Relationship Type <span>{{hintContent}}</span> not
        found, please create or
        enter a new one
    </label>
    <label [hidden]="!hintContent" class="item-label-error">
        {{hintContent}}
    </label>
</div>